import type { ContentfulClientApi, EntryFieldTypes, EntrySkeletonType } from "contentful";

import { getRootDispatcher } from "@/analytics";

interface QuestionFields {
    questionText: EntryFieldTypes.Symbol;
    questionId: EntryFieldTypes.Symbol;
    choices: EntryFieldTypes.Object<
        { choice: string; isCorrectAnswer: boolean; correctionText?: string; confirmationText?: string }[]
    >;
}

export const getQuestionFromContentful = async (
    questionId: string,
    contentfulClient: ContentfulClientApi<undefined>,
) => {
    const dispatcher = getRootDispatcher().withExtra({ module: "questionnaire" });
    const response = await contentfulClient.withoutUnresolvableLinks.getEntries<
        EntrySkeletonType<QuestionFields, "triviaQuestion">
    >({
        content_type: "triviaQuestion",
        "fields.questionId": questionId,
    });

    if (!response.items.length) {
        void dispatcher.dispatchAction("getQuestionsFromContentful", "Expert has no questions left");
        throw new Error(`No trivia question with matching id found: ${questionId}`);
    }
    return response.items
        .filter((question) => question !== undefined)
        .map(({ fields: { questionText: question, choices, questionId } }) => ({
            question,
            choices,
            questionId,
        }))[0];
};
